export default __webpack_public_path__ + "static/media/poufs.547a341a.jpg";